import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import CustomModelSelectCard from './modelSelectCard';
import { getSVG } from 'src/actions/modelActions';

const useStyles = createUseStyles({
	cardList: {
		display: 'flex',
		flexWrap: 'wrap',
	},
});

const CustomModelSelectCardList = (props) => {
	const classes = useStyles();
	const [ImagesLoaded, setImagesLoaded] = useState(true);
	const { models, current } = props;

	// hook in order to check whether the images where already loaded from the backend or not
	useEffect(() => {
		let allChecked = true;

		for (let index = 0; index < models.length; index++) {
			if (models[index].img !== 0 && !models[index].img) {
				allChecked = false;
				setImagesLoaded(false);
				break;
			}
		}

		if (!allChecked) {
			const modelImages = models.map(async (model) => {
				try {
					const svg = await getSVG(model._id, 'root');
					model.img = svg;
				} catch (error) {
					model.img = 0;
				}
			});
			// if all images loaded set boolean to true in order to render cardlist with images
			Promise.all(modelImages).then(() => {
				setImagesLoaded(true);
			});
		}
	}, [models]);

	return (
		<div className={classes.cardList}>
			{models.map((model) => (
				<CustomModelSelectCard model={model} key={model._id} ImagesLoaded={ImagesLoaded} current={current} />
			))}
		</div>
	);
};

export default CustomModelSelectCardList;
